/* Reya · Category rail — expands the chosen panel, moves the progress marker, syncs mobile swipe. */
(() => {
  if (customElements.get('rr-category-rail')) return;
  const mobile = window.matchMedia('(max-width: 749px)');
  const canHover = window.matchMedia('(hover: hover)');

  customElements.define(
    'rr-category-rail',
    class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-rr-crl-rail]');
        this.panels = [...this.querySelectorAll('[data-rr-crl-panel]')];
        this.fill = this.querySelector('[data-rr-crl-fill]');
        if (!this.rail || !this.panels.length) return;
        this.index = Math.min(+this.dataset.active || 0, this.panels.length - 1);
        this.set(this.index, false);
        requestAnimationFrame(() => { if (mobile.matches) this.rail.scrollLeft = this.index * this.rail.clientWidth; });

        this.panels.forEach((p, i) => {
          p.addEventListener('mouseenter', () => { if (canHover.matches && !mobile.matches) this.set(i); });
          p.addEventListener('focusin', () => { if (!mobile.matches) this.set(i); });
          // Touch on desktop-width screens: first tap opens the panel, second tap follows the link
          p.querySelector('a').addEventListener('click', (e) => {
            if (!mobile.matches && !canHover.matches && i !== this.index) { e.preventDefault(); this.set(i); }
          });
        });
        this.querySelectorAll('[data-rr-crl-go]').forEach((b) =>
          b.addEventListener('click', () => this.set(+b.dataset.rrCrlGo, true, true))
        );

        let t;
        this.rail.addEventListener('scroll', () => {
          if (!mobile.matches) return;
          clearTimeout(t);
          t = setTimeout(() => {
            const i = Math.round(this.rail.scrollLeft / this.rail.clientWidth);
            if (i !== this.index) this.set(i, true, false);
          }, 80);
        }, { passive: true });

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            const i = this.panels.findIndex((p) => p.contains(e.target) || p === e.target);
            if (i > -1) this.set(i, true, true);
          });
        }
      }

      set(i, animate = true, scroll = false) {
        i = Math.max(0, Math.min(i, this.panels.length - 1));
        this.index = i;
        this.panels.forEach((p, n) => p.classList.toggle('is-active', n === i));
        this.querySelectorAll('.rr-crl__step').forEach((s, n) => s.classList.toggle('is-active', n === i));
        this.querySelectorAll('.rr-crl__tab').forEach((s, n) => s.setAttribute('aria-selected', n === i ? 'true' : 'false'));
        if (this.fill) this.fill.style.width = `${this.panels.length > 1 ? (i / (this.panels.length - 1)) * 100 : 0}%`;
        if (scroll && mobile.matches) {
          this.rail.scrollTo({ left: i * this.rail.clientWidth, behavior: animate ? 'smooth' : 'auto' });
          const tab = this.querySelectorAll('.rr-crl__tab')[i];
          tab && tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      }
    }
  );
})();
